import React from "react";

export default function UserAvgCompletionTime({ user }) {

    const time = "19m 42s";
    const delta = -1.2;

    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%", padding: "10px" }}>
            <div style={{ fontSize: "22px", fontWeight: 600 }}>{time}</div>
            <div style={{ color: delta >= 0 ? "green" : "red", fontSize: "12px" }}>
                {delta}% vs org avg
            </div>
        </div>
    );
}
